import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../../../services/admin/admin.service';
import { ChainPost } from '../../../interfaces/chain';

type AddChainForm = {
  name: FormControl<string>;
  email: FormControl<string>;
  password: FormControl<string>;
};

@Component({
  selector: 'app-add-chain',
  templateUrl: './add-chain.component.html',
  styleUrls: ['./add-chain.component.scss']
})
export class AddChainComponent  {

  public loading = false;
  public addChainForm: FormGroup<AddChainForm> = this.generateForm();

  constructor(
    public dialogRef: MatDialogRef<ChainPost>,
    private translate: TranslateService,
    private admin: AdminService,
  ) { }


  private generateForm(): FormGroup<AddChainForm> {
    return new FormGroup({
      name: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      email: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.email] }),
      password: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(4), Validators.maxLength(30)]
      })
    });
  }

  addChain(form: FormGroup<AddChainForm>): void {
    this.loading = true;
    const newChain = form.getRawValue();

    this.admin.addNewChain(newChain).subscribe(
      (data: ChainPost) => {
        this.dialogRef.close(data);
        this.loading = false;
      },
      () => this.loading = false
    );
  }

}
